export const getOrderDetails = '/orders/get-order-details/';
export const getSlotsByDateType = '/slot/get-slot-by-date-and-type-for-web';
export const updateOrderStatus = '/orders/update-order-status';
export const changeDeliverySlot = '/orders/change-order-slot';
